import * as React from "react";
import type { SVGProps } from "react";
const SvgExitDrawingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="exit-drawing_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M151.723 430.165a85.333 85.333 0 0 1 20.053-31.616l269.91-269.952a178.176 178.176 0 1 1 251.989 251.947L423.68 650.496a85.333 85.333 0 0 1-31.616 20.053l-204.33 72.918C119.935 767.7 54.442 702.25 78.676 634.41l73.003-204.288zm80.341 28.715-72.96 204.288 204.288-73.003 269.952-269.952a92.843 92.843 0 0 0-131.328-131.285L232.106 458.88z"
    />
    <path
      fill="currentColor"
      d="M390.997 199.125a42.667 42.667 0 0 1 60.331 0l156.587 156.587a42.667 42.667 0 0 1-60.331 60.33L390.997 259.457a42.667 42.667 0 0 1 0-60.33zM174.08 416.085a42.667 42.667 0 0 1 60.33 0l156.587 156.587a42.667 42.667 0 1 1-60.33 60.33L174.08 476.417a42.667 42.667 0 0 1 0-60.33zM721.664 512a42.667 42.667 0 0 1 42.667-42.667h89.002a85.333 85.333 0 0 1 85.334 85.334v309.632a85.333 85.333 0 0 1-85.334 85.333h-89.002a42.667 42.667 0 1 1 0-85.333h89.002V554.667h-89.002A42.667 42.667 0 0 1 721.664 512zm-51.499 55.168a42.667 42.667 0 0 1 0 60.33l-128 128a42.667 42.667 0 0 1-60.33-60.33l128-128a42.667 42.667 0 0 1 60.33 0z"
    />
    <path
      fill="currentColor"
      d="M481.835 695.168a42.667 42.667 0 0 1 60.33 0l128 128a42.667 42.667 0 0 1-60.33 60.33l-128-128a42.667 42.667 0 0 1 0-60.33z"
    />
    <path
      fill="currentColor"
      d="M469.333 725.333A42.667 42.667 0 0 1 512 682.667h213.333a42.667 42.667 0 1 1 0 85.333H512a42.667 42.667 0 0 1-42.667-42.667z"
    />
  </svg>
);
export default SvgExitDrawingIcon;
